import { Modal, Button } from "react-bootstrap";

import "./index.scss";

const ErrorModal = ({ show, onClose, message }) => {
  return (
    <Modal centered show={show} onHide={onClose} className="error-modal">
      <Modal.Header closeButton>
        <Modal.Title>Warning!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="error-modal__icon">
          <img
            alt="Error"
            width="50"
            height="50"
            src={require("../../../../assets/gif/Warning.gif")}
          />
        </div>
        <div className="error-modal__message">{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="p-2 w-50" variant="primary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
